<template>
    <div class="fourSymbolsLineDiagram">
        <div :id="'ElephantLine_' + id_type" class="ElephantLine"></div>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['id_type', 'ownexamData', 'username', 'reportType', 'CurrentEvaluationId'],
    data() {
        return {

        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        initChart() {
            let that = this;
            this.$echarts.init(document.getElementById(`ElephantLine_${this.id_type}`)).dispose();
            let myChart = this.$echarts.init(document.getElementById(`ElephantLine_${this.id_type}`));
            myChart.setOption({
                title: {
                    text: that.username + ' ' + that.reportType,
                    // text: that.username,
                    left: 'center',
                    textStyle: {
                        fontWeight: "normal"
                    },
                },
                tooltip: {
                    show: true,
                    trigger: 'item',
                    formatter: function (params) {
                        // return `试卷名称: ${that.ownexamData[params.dataIndex].name}<br/>测评日期: ${that.dayjs(that.ownexamData[params.dataIndex].create_at).format("YYYY-MM-DD")}`;
                        return `试卷名称: ${params.data.itemName}<br/>测评日期: ${that.dayjs(params.data.createAt).format("YYYY-MM-DD")}`;
                    },
                    position: 'right'
                },
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: -100,
                        endValue: 100,
                    }
                ],
                grid: {
                    left: '15%',
                    right: '15%',
                },
                xAxis: {
                    type: 'value',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                    },
                    splitLine: {
                        show: false
                    },
                    interval: 10,
                },
                yAxis: {
                    type: 'value',
                    min: 40,
                    max: 100,
                    axisLine: {
                        onZero: false,
                    },
                    splitLine: {
                        show: false
                    },
                    interval: 10,
                },
                series: [{
                    type: 'scatter',
                    data: that.generateData(),
                    // symbol: 'diamond',
                    markLine: {
                        symbol: ['none', 'arrow'],
                        silent: true,
                        lineStyle: {        // 👈 添加这一块
                            type: 'solid',  // 👈 设置为实线
                            width: 1,
                            color: '#333'   // 可选：设置颜色
                        },
                        data: [
                            {
                                xAxis: 69.32, // 纵轴线
                                label: {
                                    show: true,
                                    position: 'start',
                                    formatter: '大众型'
                                }
                            },
                            {
                                yAxis: 64.75, // 横轴线
                                label: {
                                    show: true,
                                    position: 'start',
                                    formatter: '自然成长'
                                }
                            },
                            {
                                xAxis: 69.32, // 纵轴线
                                label: {
                                    show: true,
                                    position: 'end',
                                    formatter: '天赋型'
                                }
                            },
                            {
                                yAxis: 64.75, // 横轴线
                                label: {
                                    show: true,
                                    position: 'end',
                                    formatter: '笃行不倦'
                                }
                            }
                        ],
                    }
                }]
            })
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        generateData() {
            const targetIndex = this.ownexamData.findIndex(item => item.test_id == this.CurrentEvaluationId);
            let data = [];
            for (let index = 0; index < this.ownexamData.length; index++) {
                const item = this.ownexamData[index];
                const isHighlight = item.test_id === this.CurrentEvaluationId;
                data.push({
                    value: [item.x, item.y],
                    itemId: item.id,
                    itemName: item.name,
                    createAt: item.create_at,
                    itemStyle: {
                        color: isHighlight ? '#f59a23' : '#5470C6',
                        borderWidth: isHighlight ? 2 : 0
                    },
                    symbolSize: isHighlight ? 15 : 12,
                    lineStyle: {
                        type: 'solid',
                        color: '#aaa'
                    },
                    // 标签也可以动态控制
                    label: {
                        show: true,
                        position: 'top',
                        formatter: () => String(index + 1),
                        fontSize: isHighlight ? 16 : 13,
                        fontWeight: isHighlight ? 'bold' : 'normal',
                        color: isHighlight ? '#f59a23' : '#333'
                    }
                });
            }
            return data;
        },
    },

    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        this.initChart();
    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style scoped lang="less">
.fourSymbolsLineDiagram {
    width: 100%;
    height: 100%;

    .ElephantLine {
        width: 100%;
        height: 100%;
    }
}
</style>